// extracted by mini-css-extract-plugin
export default {"f":"e79a95bab0","main":"_7b2b51ffe6","btn":"dcef455fb0","w":"_27b76f4350","h":"_42a93085e3","lh25":"_65eac9c564","wb":"_56da7a89f0","b":"cdf89da742","bx":"fe8591a171"};